"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRangeText = exports.formatRangeValue = exports.EMISSION_FRACTION_DIGITS = exports.CONSUMPTION_FRACTION_DIGITS = exports.RANGES_DASH_CHAR = void 0;
const utils_1 = require("../formatter/utils");
exports.RANGES_DASH_CHAR = "–";
exports.CONSUMPTION_FRACTION_DIGITS = 1;
exports.EMISSION_FRACTION_DIGITS = 0;
const formatRangeValue = (locale, range, fraction) => {
    const min = (0, utils_1.formatDecimal)(locale, range.min || 0, fraction);
    const max = (0, utils_1.formatDecimal)(locale, range.max || 0, fraction);
    if (min === max) {
        return `${min} ${range.unit}`;
    }
    return `${max}${exports.RANGES_DASH_CHAR}${min} ${range.unit}`;
};
exports.formatRangeValue = formatRangeValue;
const formatRangeText = (range) => {
    if (range.min === range.max) {
        return `${range.min}`;
    }
    return `${range.max}${exports.RANGES_DASH_CHAR}${range.min}`;
};
exports.formatRangeText = formatRangeText;
